import useFetch from './fetch';

export default function useGetTagKeys() {
  const fetch = useFetch();
  return (tagId) => { return fetch(`/api/tags/${tagId}/keys`).then(x => x.json()) };
};
